// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mXlRV","type":"styles_type__Ih_gG","choices":"styles_choices__U3_iz"};